import { ErrorReport } from 'HelpCenter';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { errorReportActions, userActions } from '_actions';
import { RouteDefs } from '_constants';
import { history } from '_helpers';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: undefined,
            info: undefined
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        this.setState((state) => {
            return { error, info };
        })
        if (!this.props.submitting && !this.props.erno) {
            this.props.send('Triggered by REACT', error, info);
        }
    }

    newlineText(input) {
        const text = input;
        var key = 1;
        const newText = text.split('\n').map(str => <p key={key++}>{str}</p>);
        return newText;
    }

    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Something went wrong.</h1>
                    <div>Please stand by.  We're gathering some data for the support team to look into.</div>
                    <div>If you receive this message consistently when perform an action in Sapphire, please reach out to the support team with details including patient SYS# if applicable.</div>
                    {!this.props.submitting && this.props.erno &&
                        <div>

                            <button style={{ margin: 100 }} onClick={() => history.push(RouteDefs.loginPage.path)}>Back to Login</button>
                        </div>
                    }
                    {process.env.REACT_APP_ENV !== 'production' && this.state.error && this.state.error.message &&
                        <div>
                            <p><b>Message:</b></p>
                            {this.newlineText(this.state.error.message)}
                        </div>
                    }
                    {process.env.REACT_APP_ENV !== 'production' && this.state.error && this.state.error.stack &&
                        <div>
                            <p><b>Stack:</b></p>
                            {this.newlineText(this.state.error.stack)}
                        </div>
                    }
                    <ErrorReport />
                </div>
            );
        }
        return this.props.children;
    }
}

function mapStateToProps(state) {
    let submitting = state.ui.errorReport.submitting;
    let erno = state.ui.errorReport.lastErno;
    return {
        submitting,
        erno
    };
}


function mapDispatchToProps(dispatch) {
    return {
        send: bindActionCreators(errorReportActions.send, dispatch),
        logout: bindActionCreators(userActions.logout, dispatch)
    };
}

const connectedErrorBoundary = connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
export { connectedErrorBoundary as ErrorBoundary }